module.exports = __webpack_public_path__ + "static/subpages-style-mobile.0b82fd26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/subpages-style-mobile.jpg
// module id = 598
// module chunks = 168179225184413